module.exports = __webpack_public_path__ + "static/media/close-icon.3658fd9e.svg";